import { useState, useEffect } from "react"

export const useLoadingProgress = () => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (count < 100) {
      interval = setInterval(() => {
        setCount(count + 1)
      }, 20) // Здесь 20 миллисекунд для плавной анимации от 0 до 100
    }

    // Остановка интервала после 2 секунд (2000 миллисекунд)
    setTimeout(() => {
      clearInterval(interval)
    }, 2000)

    return () => {
      clearInterval(interval) // Очистка интервала при размонтировании компонента
    }
  }, [count])

  return count
}
